export const ALL_OPTIONS_ID = '<all>'

export const ROWS_PER_PAGE = 10

export const EMPTY_PORTAL_DATA = {
  id: 0,
  name: '',
  timestamp: '',
  vendor_id: '',
  media_library_files: [],
  deal_reg_forms: [],
  partner_info_forms: [],
  partners: [],
  announcements: [],
  campaign_templates: [],
}

export const DEFAULT_HEX_COLOR = '#000000'
